import React from 'react'
import { Box, Heading, Text } from '@chakra-ui/react'
import { chartStyles } from '../styles'

interface ChartPanelProps {
  symbol: string
}

const ChartPanel: React.FC<ChartPanelProps> = ({ symbol }) => {
  const { height, width } = chartStyles
  const chartUrl = `https://widget.finnhub.io/widgets/stocks/chart?symbol=${symbol}&watermarkColor=%231db954&backgroundColor=%23222222&textColor=white`
  
  return (
    <Box>
      <Heading as="h3" mb={4} size="md">Stock Price Chart</Heading>
      <Box borderRadius="md" overflow="hidden" shadow="md">
        <iframe
          height={height}
          src={chartUrl}
          style={{ border: 'none' }}
          title={`${symbol} Stock Chart`}
          width={width}
        />
      </Box>
      <Text color="gray.500" fontSize="xs" mt={2} textAlign="right">
        Powered by Finnhub
      </Text>
    </Box>
  )
}

export default ChartPanel
